<template>
  <div :style="loginStyle" class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0 justify-content-center">
      <b-col lg="11" class="pt-5 pl-3">
        <InitialHeader :onlyLogo="true" />
      </b-col>
      <b-col
          sm="12"
          md="12"
          lg="11"
          class="d-flex align-items-center mb-5"
      >
        <b-col
            sm="12"
            md="10"
            lg="4"
            class="mx-auto auth-bg p-2 rounded"
        >
          <div id="esqueci-senha" class="px-xl-3 pb-1 pt-3">
            <h2 class="mb-1 auth-title">
              Esqueceu sua senha?
            </h2>
            <p class="text-muted mb-1">
              Preencha seu email e nós enviaremos as próximas instruções.
            </p>
          </div>

          <div id="recuperar" class="px-xl-3 pt-1 pb-3">
            <b-alert
                v-if="errorMessage"
                show
                fade
                class="mb-2"
                variant="danger"
            >
              <div class="custom-alert">
                <span>{{ errorMessage }}</span>
              </div>
            </b-alert>

            <validation-observer ref="emailRules">
              <b-form class="auth-login-form mt-2" @submit.prevent="forgotPassword">
                <b-form-group label="Email" label-for="forgot-email">
                  <validation-provider
                    #default="{ errors }"
                    name="email"
                    rules="required|email"
                  >
                    <b-form-input
                        id="forgot-email"
                        v-model="form.email"
                        name="forgot-email"
                        type="email"
                        placeholder="seu@email.com"
                        autocomplete="email"
                        :state="errors.length > 0 ? false : null"
                        @focus="errorMessage = ''"
                    />
                    <small v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </small>
                  </validation-provider>
                </b-form-group>

              <button
                  :disabled="loading"
                  type="submit"
                  class="btn button-form btn-block"
              >
                {{ loading ? 'Enviando...' : 'Enviar' }}
              </button>
              </b-form>
            </validation-observer>

            <p class="text-center mt-2">
              <b-link :to="{name:'public-login'}">
                <feather-icon icon="ChevronLeftIcon" size="16" />
                <span class="to-login">&nbsp;Volte ao Login</span>
              </b-link>
            </p>
          </div>
        </b-col>
      </b-col>
      <FooterInitial />
    </b-row>
  </div>
</template>

<script>
import {
  BAlert,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BLink,
  BRow,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import FooterInitial from '@/views/components/custom/footer/FooterInitial.vue'
import InitialHeader from '@/views/components/custom/page-header/InitialHeader.vue'
import api from "@/libs/api";
import rotasAPI from "@/router/rotasAPI";

export default {
  name: 'PublicForgotPassword',
  components: {
    BAlert,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BLink,
    BRow,
    ValidationProvider,
    ValidationObserver,
    FooterInitial,
    InitialHeader,
  },
  data() {
    return {
      required,
      email,
      form: {
        email: '',
      },
      loading: false,
      errorMessage: '',
      loginStyle: {
        'background-image': `url(${require('@/assets/custom-images/bg/bg-login.png')})`,
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        'background-size': 'cover',
      },
    }
  },
  methods: {
    async forgotPassword() {
      this.errorMessage = ''
      
      const isValid = await this.$refs.emailRules.validate()
      if (!isValid) {
        return
      }

      const email = this.form.email.trim()

      this.loading = true
      try {
        await api.post(rotasAPI.acessoPublicoRecuperarSenha(email));

        this.$router.push({ 
          name: 'public-forgot-password-success',
          params: { cpf: email }
        })
      } catch (error) {
        console.error(error)
        this.$router.push({
          name: 'public-forgot-password-success',
          params: { cpf: email }
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
